// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"5e542dee","553":"bd2da085","977":"de3dd0af"}[chunkId] + ".chunk.js";
};